import React from 'react'

import Menu from '../../components/menu/menu'

const About = ({open, setOpen}) => {
  return (
    <div>
      <Menu open={open} setOpen={setOpen}/>
      <h2>About</h2>
    </div>
  )
}

export default About